
function formatReal(int) {
  var tmp = int + '';

  tmp = tmp.replace(/([0-9]{2})$/g, ",$1");

  if (tmp.length > 6) {
    tmp = tmp.replace(/([0-9]{3}),([0-9]{2}$)/g, ".$1,$2");
  }

  return tmp;
}

const total = localStorage.getItem('totalPrice');

if (total && $('.customPrice').length) {
  $('.customPrice').text(formatReal(total));
}

const select = $('<select>');
select.append(
  $('<option>')
    .text('Selecione o modelo')
    .attr('value', '')
    .prop('disabled', true)
    .prop('selected', true)
);

// cp-model-selection-v2
function hasSelectedModel(value) {
  return Boolean(value && value !== '-');
}

// cp-fixed-multi-strap-kits-v3
const CP_MAX_FIXED_KIT_STRAP_UNITS = 3;
let itensadd = [];
let handleProducts = $('.handleProduct');
const nativeBundleConfigElements = document.querySelectorAll('[data-cp-native-bundle-10-config]');
const nativeBundleRequested = nativeBundleConfigElements.length > 0;
let nativeBundleConfig = null;
let nativeBundleSelectedVariant = null;
let kitComponents = [];
let kitCaseComponent = null;
let kitStrapComponents = [];
let kitLoadFinished = !nativeBundleRequested && handleProducts.length === 0;
let kitLoadError = '';
let kitRequestInFlight = false;
let modelo;
let valorInicial = '';
let valorSelecionado = '';

function productHasKitTag(product, tag) {
  const tags = Array.isArray(product && product.tags)
    ? product.tags
    : String((product && product.tags) || '').split(',');

  return tags.some(function (candidate) {
    return String(candidate).trim() === tag;
  });
}

function showKitError(message, details, fatal) {
  const technicalDetails = details || message;
  if (fatal !== false) {
    kitLoadError = technicalDetails;
  }
  console.error('Erro na configuração do kit:', technicalDetails);

  const errorElement = document.getElementById('mensagemErro');
  if (errorElement) {
    errorElement.innerText = message;
    errorElement.style.display = 'block';
  }
}

function clearKitError() {
  const errorElement = document.getElementById('mensagemErro');
  if (errorElement) {
    errorElement.innerText = '';
    errorElement.style.display = 'none';
  }
}

function parseNativeBundlePositiveInteger(value, label) {
  const rawValue = String(value || '').trim();
  const parsedValue = Number(rawValue);
  if (!/^\d+$/.test(rawValue) || !Number.isSafeInteger(parsedValue) || parsedValue <= 0) {
    throw new Error(label + ' inválido no kit nativo.');
  }
  return parsedValue;
}

function readNativeBundleConfiguration() {
  if (nativeBundleConfigElements.length !== 1) {
    throw new Error('O kit nativo precisa ter exatamente uma configuração Liquid.');
  }

  const configElement = nativeBundleConfigElements[0];
  const productId = parseNativeBundlePositiveInteger(
    configElement.getAttribute('data-product-id'),
    'Produto pai'
  );
  const productFormId = String(configElement.getAttribute('data-product-form-id') || '').trim();
  if (!productFormId) {
    throw new Error('O formulário do produto pai não foi informado pelo Liquid.');
  }
  const variantCount = parseNativeBundlePositiveInteger(
    configElement.getAttribute('data-variant-count'),
    'Quantidade de variantes'
  );
  const modelOptionCount = parseNativeBundlePositiveInteger(
    configElement.getAttribute('data-model-option-count'),
    'Quantidade de opções de modelo'
  );
  if (modelOptionCount !== 1) {
    throw new Error('O kit nativo precisa ter exatamente uma opção de modelo.');
  }
  const defaultPrice = parseNativeBundlePositiveInteger(
    configElement.getAttribute('data-default-price'),
    'Preço pai'
  );
  const variantElements = configElement.querySelectorAll('[data-cp-native-bundle-variant]');
  if (variantElements.length !== variantCount) {
    throw new Error('A lista Liquid de variantes do kit nativo está incompleta.');
  }

  const seenIds = {};
  const variants = Array.prototype.map.call(variantElements, function (variantElement) {
    const id = parseNativeBundlePositiveInteger(
      variantElement.getAttribute('data-id'),
      'Variante pai'
    );
    const model = String(variantElement.getAttribute('data-model') || '').trim();
    const price = parseNativeBundlePositiveInteger(
      variantElement.getAttribute('data-price'),
      'Preço da variante pai'
    );
    const availableValue = String(variantElement.getAttribute('data-available') || '');

    if (seenIds[id] || !model || model === '-' || (availableValue !== 'true' && availableValue !== 'false')) {
      throw new Error('Uma variante pai do kit nativo possui dados inválidos ou repetidos.');
    }
    seenIds[id] = true;

    return {
      id: id,
      model: model,
      price: price,
      available: availableValue === 'true'
    };
  });

  if (!variants.some(function (variant) { return variant.available; })) {
    throw new Error('O kit nativo não possui variantes disponíveis.');
  }

  return {
    productId: productId,
    productFormId: productFormId,
    defaultPrice: defaultPrice,
    variants: variants
  };
}

function renderNativeBundlePrice(price) {
  if (!Number.isSafeInteger(price) || price <= 0) {
    throw new Error('O preço pai do kit nativo é inválido.');
  }
  try {
    localStorage.setItem('totalPrice', price);
  } catch (storageError) {
    console.warn('Não foi possível salvar o preço do kit nativo.', storageError);
  }
  if ($('.customPrice').length) {
    $('.customPrice').text(formatReal(price));
  }
}

function syncNativeBundleSelectionFromParent() {
  const dropKit = $('#selectOptionKit');
  if (!dropKit.length || !nativeBundleConfig) {
    throw new Error('O seletor de modelo do kit nativo não foi encontrado.');
  }

  const selectedModel = String(dropKit.val() || '').trim();
  nativeBundleSelectedVariant = null;
  modelo = '';
  valorInicial = '';

  if (!selectedModel) {
    renderNativeBundlePrice(nativeBundleConfig.defaultPrice);
    clearKitError();
    updateKitActionState();
    return;
  }

  const matches = nativeBundleConfig.variants.filter(function (variant) {
    return variant.model === selectedModel;
  });
  if (matches.length !== 1 || matches[0].available !== true) {
    throw new Error('O modelo selecionado não corresponde a uma variante pai disponível.');
  }

  nativeBundleSelectedVariant = matches[0];
  modelo = matches[0].model;
  valorInicial = String(matches[0].id);
  renderNativeBundlePrice(matches[0].price);
  clearKitError();
  updateKitActionState();
}

function readNativeBundleQuantity() {
  if (!nativeBundleConfig) {
    throw new Error('A configuração do kit nativo não foi carregada.');
  }

  const quantityInputs = Array.prototype.filter.call(
    document.querySelectorAll('[name="quantity"]'),
    function (input) {
      return input.form && input.form.id === nativeBundleConfig.productFormId;
    }
  );
  if (quantityInputs.length > 1) {
    throw new Error('O formulário do kit nativo possui quantidades conflitantes.');
  }
  if (quantityInputs.length === 0) {
    return 1;
  }

  return parseNativeBundlePositiveInteger(
    quantityInputs[0].value,
    'Quantidade do kit nativo'
  );
}

function updateKitActionState() {
  $('.CustomAddKit').hide().attr('aria-disabled', 'true');
  $('.CustomChamaModal').hide();

  if (kitLoadError || !kitLoadFinished) {
    return;
  }

  if (!hasSelectedModel(valorInicial)) {
    $('.CustomChamaModal').show();
    return;
  }

  if (!kitRequestInFlight) {
    $('.CustomAddKit').show().attr('aria-disabled', 'false');
  }
}

function readFixedKitConfiguration() {
  const quantityRules = {};
  let configurationError = '';

  $('.kitQuantityRule').each(function () {
    const handle = String($(this).attr('data-handle') || '').trim();
    const quantity = Number($(this).attr('data-quantity'));
    const partCount = Number($(this).attr('data-parts'));

    if (
      partCount !== 3 ||
      !handle ||
      !Number.isInteger(quantity) ||
      quantity < 2 ||
      quantity > CP_MAX_FIXED_KIT_STRAP_UNITS ||
      Object.prototype.hasOwnProperty.call(quantityRules, handle)
    ) {
      configurationError = 'Regra de quantidade inválida para ' + (handle || 'componente desconhecido') + '.';
      return false;
    }

    quantityRules[handle] = quantity;
  });

  const seenHandles = {};
  const components = [];
  handleProducts.each(function () {
    const handle = String($(this).val() || '').trim();
    const renderedQuantity = Number($(this).attr('data-quantity') || 1);
    const stockSufficientValue = String($(this).attr('data-stock-sufficient') || '');

    if (
      !handle ||
      seenHandles[handle] ||
      !Number.isInteger(renderedQuantity) ||
      renderedQuantity < 1 ||
      renderedQuantity > CP_MAX_FIXED_KIT_STRAP_UNITS ||
      (stockSufficientValue !== 'true' && stockSufficientValue !== 'false')
    ) {
      configurationError = 'Componente inválido ou repetido: ' + (handle || 'desconhecido') + '.';
      return false;
    }

    const expectedQuantity = quantityRules[handle] || 1;
    if (renderedQuantity !== expectedQuantity) {
      configurationError = 'Quantidade divergente para ' + handle + '.';
      return false;
    }

    seenHandles[handle] = true;
    components.push({
      handle: handle,
      quantity: expectedQuantity,
      stockSufficient: stockSufficientValue === 'true'
    });
  });

  Object.keys(quantityRules).some(function (handle) {
    if (!seenHandles[handle]) {
      configurationError = 'Quantidade sem componente correspondente: ' + handle + '.';
      return true;
    }
    return false;
  });

  if (configurationError) {
    throw new Error(configurationError);
  }

  return components;
}

function obterProduto(handle) {
  return new Promise(function (resolveProduct, rejectProduct) {
    $.ajax({
      type: 'GET',
      url: '/products/' + handle + '.js',
      dataType: 'json',
      success: function (product) {
        if (!product || !Array.isArray(product.variants) || !product.variants.length) {
          rejectProduct(new Error('Produto sem variantes: ' + handle + '.'));
          return;
        }
        resolveProduct(product);
      },
      error: function () {
        rejectProduct(new Error('Não foi possível carregar ' + handle + '.'));
      }
    });
  });
}

function syncKitModelFromParent() {
  const dropKit = $('#selectOptionKit');
  if (!dropKit.length || !$('#CustomSelect select').length) {
    return;
  }

  const selectedId = dropKit.find('option:selected').attr('data-id');
  $('#CustomSelect select').val(selectedId || '');
  select.trigger('change');
}

function validateLoadedKitComponents(components) {
  const cases = components.filter(function (component) {
    return productHasKitTag(component.product, 'custom_variant') &&
      !productHasKitTag(component.product, 'modelo_estoque');
  });
  const straps = components.filter(function (component) {
    return productHasKitTag(component.product, 'modelo_estoque') &&
      !productHasKitTag(component.product, 'custom_variant');
  });

  if (cases.length !== 1 || cases.length + straps.length !== components.length) {
    throw new Error('O kit precisa ter uma case e somente alças de estoque.');
  }
  if (cases[0].quantity !== 1) {
    throw new Error('A case precisa ter quantidade 1.');
  }

  const strapUnits = straps.reduce(function (sum, component) {
    return sum + component.quantity;
  }, 0);
  if (strapUnits < 1 || strapUnits > CP_MAX_FIXED_KIT_STRAP_UNITS) {
    throw new Error('O kit precisa ter entre 1 e 3 unidades de alça.');
  }
  if (straps.some(function (component) {
    return component.product.variants.length !== 1 ||
      component.product.variants[0].available !== true ||
      component.stockSufficient !== true;
  })) {
    throw new Error('Uma alça está indisponível ou possui configuração inválida.');
  }

  const availableCaseVariants = cases[0].product.variants.filter(function (variant) {
    return variant.available === true && variant.title !== '-';
  });
  if (!availableCaseVariants.length) {
    throw new Error('A case não possui modelos disponíveis.');
  }

  return {
    caseComponent: cases[0],
    strapComponents: straps,
    availableCaseVariants: availableCaseVariants
  };
}

function populateKitModelSelect(variants) {
  select.find('option').not(':first').remove();
  variants.forEach(function (variant) {
    select.append(
      $('<option>')
        .text(variant.title)
        .attr('id', variant.id)
        .attr('name', variant.title)
        .attr('value', variant.id)
    );
  });

  if ($('#CustomSelect').length) {
    $('#CustomSelect').empty().append(select);
  }
}

function buildFixedKitCartItems() {
  const selectedCaseVariant = kitCaseComponent.product.variants.find(function (variant) {
    return String(variant.id) === String(valorInicial) && variant.available === true;
  });
  if (!selectedCaseVariant) {
    throw new Error('O modelo escolhido da case não está mais disponível.');
  }

  const items = [{ id: selectedCaseVariant.id, quantity: 1 }];
  kitStrapComponents.forEach(function (component) {
    const strapVariant = component.product.variants[0];
    const existing = items.find(function (item) {
      return item.properties && String(item.id) === String(strapVariant.id);
    });

    if (existing) {
      existing.quantity += component.quantity;
    } else {
      items.push({
        id: strapVariant.id,
        quantity: component.quantity,
        properties: { Modelo: modelo }
      });
    }
  });

  return items;
}

function buildNativeBundleCartItems() {
  if (!nativeBundleConfig || !nativeBundleSelectedVariant) {
    throw new Error('Selecione um modelo disponível do kit nativo.');
  }

  const matches = nativeBundleConfig.variants.filter(function (variant) {
    return variant.id === nativeBundleSelectedVariant.id &&
      variant.model === nativeBundleSelectedVariant.model &&
      variant.price === nativeBundleSelectedVariant.price &&
      variant.available === true;
  });
  if (matches.length !== 1 || String(matches[0].id) !== String(valorInicial)) {
    throw new Error('A variante pai selecionada do kit nativo não é válida.');
  }

  return [{
    id: matches[0].id,
    quantity: readNativeBundleQuantity()
  }];
}

select.on('change', function () {
  const selectedValue = $(this).val();
  const selectedOption = $(this).find('option:selected');

  modelo = selectedOption.attr('name') || '';
  valorInicial = selectedValue || '';
  updateKitActionState();
});

if ($('.CustomChamaModal').length) {
  $('.CustomChamaModal').click(function () {
    $('.modalCustom').show();
  });
}

if ($('.closeCustom').length) {
  $('.closeCustom').click(function () {
    $('.modalCustom').hide();
  });
}

if (nativeBundleRequested) {
  updateKitActionState();

  try {
    nativeBundleConfig = readNativeBundleConfiguration();
    const dropKit = $('#selectOptionKit');
    if (!dropKit.length) {
      throw new Error('O seletor de modelo do kit nativo não foi encontrado.');
    }

    dropKit.off('change.cpNativeBundle10').on('change.cpNativeBundle10', function () {
      try {
        syncNativeBundleSelectionFromParent();
      } catch (error) {
        showKitError(
          'Este kit está temporariamente indisponível. Tente novamente em instantes.',
          error.message
        );
        updateKitActionState();
      }
    });

    kitLoadFinished = true;
    clearKitError();
    syncNativeBundleSelectionFromParent();
  } catch (error) {
    kitLoadFinished = true;
    showKitError(
      'Este kit está temporariamente indisponível. Tente novamente em instantes.',
      error.message
    );
    updateKitActionState();
  }
} else if (handleProducts.length) {
  updateKitActionState();

  try {
    const configuration = readFixedKitConfiguration();
    Promise.all(configuration.map(function (component) {
      return obterProduto(component.handle).then(function (product) {
        return {
          handle: component.handle,
          quantity: component.quantity,
          stockSufficient: component.stockSufficient,
          product: product
        };
      });
    }))
      .then(function (components) {
        const topology = validateLoadedKitComponents(components);
        kitComponents = components;
        kitCaseComponent = topology.caseComponent;
        kitStrapComponents = topology.strapComponents;

        const totalPrice = components.reduce(function (sum, component) {
          return sum + Number(component.product.price || 0) * component.quantity;
        }, 0);
        try {
          localStorage.setItem('totalPrice', totalPrice);
        } catch (storageError) {
          console.warn('Não foi possível salvar o preço do kit.', storageError);
        }
        if ($('.customPrice').length) {
          $('.customPrice').text(formatReal(totalPrice));
        }

        populateKitModelSelect(topology.availableCaseVariants);
        kitLoadFinished = true;
        clearKitError();
        syncKitModelFromParent();
        updateKitActionState();
      })
      .catch(function (error) {
        kitLoadFinished = true;
        showKitError(
          'Este kit está temporariamente indisponível. Tente novamente em instantes.',
          error.message
        );
        updateKitActionState();
      });
  } catch (error) {
    kitLoadFinished = true;
    showKitError(
      'Este kit está temporariamente indisponível. Tente novamente em instantes.',
      error.message
    );
    updateKitActionState();
  }
}

if ($('#CustomAddKit').length) {
  $('#CustomAddKit').click(function () {
    if (
      kitRequestInFlight ||
      !kitLoadFinished ||
      kitLoadError ||
      !hasSelectedModel(valorInicial)
    ) {
      return;
    }

    try {
      itensadd = nativeBundleRequested
        ? buildNativeBundleCartItems()
        : buildFixedKitCartItems();
    } catch (error) {
      showKitError(error.message, error.message);
      updateKitActionState();
      return;
    }

    kitRequestInFlight = true;
    clearKitError();
    updateKitActionState();

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: itensadd })
    })
      .then(function (response) {
        if (response.ok) {
          return response.json();
        }
        return response.json().then(function (errorData) {
          throw new Error(errorData.description || 'Não foi possível adicionar o kit.');
        });
      })
      .then(function () {
        $.getJSON('/cart.js', function (cart) {
          $('.header__cart-count').text(cart.item_count);
        });

        if ($('#mini-cart').length) {
          $('#mini-cart').load(window.location.href + ' ' + '#mini-cart > *');
          $('#mini-cart').attr('open', 'true');
        }
      })
      .catch(function (error) {
        showKitError(error.message, error.message, false);
      })
      .finally(function () {
        kitRequestInFlight = false;
        updateKitActionState();
      });
  });
}

$(document).on('click', '.header__icon-wrapper.tap-area', function () {
  if ($('#mini-cart').length) {
    $('#mini-cart').load(window.location.href + " " + '#mini-cart > *');
  }
});

document.addEventListener('DOMContentLoaded', function () {
  const addToCartButton = document.getElementById('AddToCart');
  const btnFake = document.getElementById('CustomChamaModal');
  const btnFake2 = document.getElementById('CustomChamaModalCompre');
  const CustomBtnComprar = document.getElementById('Gbtn');

  const modal = document.getElementById('myModalCustom');
  const span = document.getElementsByClassName('closeCustom')[0];
  const stickyAdd = document.getElementById('StickyAddToCart');

  function isMobileDevice() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );
  }

  function breakButtonWords() {
    if (isMobileDevice()) {
      const buttons = document.querySelectorAll('.tabs-nav__item');

      buttons.forEach(function (button) {
        if (button.textContent.includes(' ')) {
          const words = button.textContent.trim().split(' ');

          if (words.length >= 2) {
            button.innerHTML = `${words[0]}<br>${words.slice(1).join(' ')}`;
          }
        }
      });
    }
  }

  window.addEventListener('load', breakButtonWords);

  const customSelectDefault = document.querySelector('.custom-select-default[data-model-selection-required]');

  if (customSelectDefault) {
    customSelectDefault.addEventListener('change', function (e) {
      const valor = e.target.value;
      valorSelecionado = valor;

      if (!hasSelectedModel(valorSelecionado)) {
        if (addToCartButton) {
          addToCartButton.style.display = 'none';
        }

        if (CustomBtnComprar) {
          CustomBtnComprar.style.display = 'none';
        }

        if (btnFake) {
          btnFake.style.display = 'block';
        }

        if (btnFake2) {
          btnFake2.style.display = 'block';
        }

        if (stickyAdd) {
          stickyAdd.setAttribute('disabled', 'disabled');
        }
      } else {
        if (addToCartButton) {
          addToCartButton.style.display = 'block';
        }

        if (btnFake) {
          btnFake.style.display = 'none';
        }

        if (btnFake2) {
          btnFake2.style.display = 'none';
        }

        if (CustomBtnComprar) {
          CustomBtnComprar.style.display = 'block';
        }
      }
    });

    customSelectDefault.dispatchEvent(new Event('change', { bubbles: true }));
  }

  if (btnFake) {
    btnFake.addEventListener('click', function () {
      if (!hasSelectedModel(valorSelecionado)) {
        if (modal) {
          modal.style.display = 'block';
        }
      } else {
        console.log('faz o envio');
      }
    });
  }

  if (stickyAdd) {
    stickyAdd.addEventListener('click', function () {
      if (!hasSelectedModel(valorSelecionado)) {
        if (modal) {
          modal.style.display = 'block';
        }
      } else {
        console.log('faz o envio');
      }
    });
  }

  if (span && modal) {
    span.onclick = function () {
      modal.style.display = 'none';
    };
  }

  if (modal) {
    window.addEventListener('click', function (event) {
      if (event.target === modal) {
        modal.style.display = 'none';
      }
    });
  }
});

window.addEventListener('load', function () {
  const optSelect = document.querySelector('.custom-select-default[data-model-selection-required]');

  if (optSelect) {
    optSelect.dispatchEvent(new Event('change', { bubbles: true }));
  }

  const dropKit = $('#selectOptionKit');
  // cp-native-bundle-legacy-dropkit-guard-v1
  if (!nativeBundleRequested && dropKit.length) {
    dropKit.on('change', function (event) {
      const item = $(event.target);
      const id = item.find(`option[value="${item.val()}"]`).attr('data-id');

      $('#CustomSelect select').val(id || '');
      select.change();
    });

    dropKit.trigger('change');
  }
});
